module.exports = {
	"ha": "vcha",
	"id": 5.5,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category and MSM Status, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 90,
						"dataLabels": {
							"enabled": false,
							"format": "72"
						},
						"color": "#043f61"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "64"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.5,
						"dataLabels": {
							"enabled": false,
							"format": "62"
						},
						"color": "#0d4440"
					},
					{
						"y": 70,
						"dataLabels": {
							"enabled": false,
							"format": "56"
						},
						"color": "#09472e"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "52"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.70491803278688,
						"dataLabels": {
							"enabled": false,
							"format": "298"
						},
						"color": "#043f61"
					},
					{
						"y": 83.27868852459017,
						"dataLabels": {
							"enabled": false,
							"format": "254"
						},
						"color": "#0c4250"
					},
					{
						"y": 79.01639344262294,
						"dataLabels": {
							"enabled": false,
							"format": "241"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.77049180327869,
						"dataLabels": {
							"enabled": false,
							"format": "225"
						},
						"color": "#09472e"
					},
					{
						"y": 63.934426229508205,
						"dataLabels": {
							"enabled": false,
							"format": "195"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.96839729119638,
						"dataLabels": {
							"enabled": false,
							"format": "434"
						},
						"color": "#043f61"
					},
					{
						"y": 87.3589164785553,
						"dataLabels": {
							"enabled": false,
							"format": "387"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.06997742663657,
						"dataLabels": {
							"enabled": false,
							"format": "368"
						},
						"color": "#0d4440"
					},
					{
						"y": 78.3295711060948,
						"dataLabels": {
							"enabled": false,
							"format": "347"
						},
						"color": "#09472e"
					},
					{
						"y": 69.75169300225733,
						"dataLabels": {
							"enabled": false,
							"format": "309"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.85994397759103,
						"dataLabels": {
							"enabled": false,
							"format": "1426"
						},
						"color": "#043f61"
					},
					{
						"y": 91.73669467787114,
						"dataLabels": {
							"enabled": false,
							"format": "1310"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.8655462184874,
						"dataLabels": {
							"enabled": false,
							"format": "1269"
						},
						"color": "#0d4440"
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "1224"
						},
						"color": "#09472e"
					},
					{
						"y": 78.57142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "1122"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#043f61"
					},
					{
						"y": 90.47619047619048,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.47619047619048,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0d4440"
					},
					{
						"y": 90.47619047619048,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#09472e"
					},
					{
						"y": 71.42857142857143,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.45454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "147"
						},
						"color": "#043f61"
					},
					{
						"y": 88.96103896103897,
						"dataLabels": {
							"enabled": false,
							"format": "137"
						},
						"color": "#0c4250"
					},
					{
						"y": 79.87012987012987,
						"dataLabels": {
							"enabled": false,
							"format": "123"
						},
						"color": "#0d4440"
					},
					{
						"y": 64.28571428571429,
						"dataLabels": {
							"enabled": false,
							"format": "99"
						},
						"color": "#09472e"
					},
					{
						"y": 49.35064935064935,
						"dataLabels": {
							"enabled": false,
							"format": "76"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.38080495356037,
						"dataLabels": {
							"enabled": false,
							"format": "321"
						},
						"color": "#043f61"
					},
					{
						"y": 91.02167182662538,
						"dataLabels": {
							"enabled": false,
							"format": "294"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.44891640866872,
						"dataLabels": {
							"enabled": false,
							"format": "276"
						},
						"color": "#0d4440"
					},
					{
						"y": 75.23219814241486,
						"dataLabels": {
							"enabled": false,
							"format": "243"
						},
						"color": "#09472e"
					},
					{
						"y": 52.32198142414861,
						"dataLabels": {
							"enabled": false,
							"format": "169"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.58275382475661,
						"dataLabels": {
							"enabled": false,
							"format": "716"
						},
						"color": "#043f61"
					},
					{
						"y": 95.54937413073714,
						"dataLabels": {
							"enabled": false,
							"format": "687"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.3769123783032,
						"dataLabels": {
							"enabled": false,
							"format": "657"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.86648122392212,
						"dataLabels": {
							"enabled": false,
							"format": "603"
						},
						"color": "#09472e"
					},
					{
						"y": 68.01112656467315,
						"dataLabels": {
							"enabled": false,
							"format": "489"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 47.32142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "53"
						},
						"color": "#043f61"
					},
					{
						"y": 39.285714285714285,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#0c4250"
					},
					{
						"y": 37.5,
						"dataLabels": {
							"enabled": false,
							"format": "42"
						},
						"color": "#0d4440"
					},
					{
						"y": 33.92857142857143,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#09472e"
					},
					{
						"y": 29.464285714285715,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.63461538461539,
						"dataLabels": {
							"enabled": false,
							"format": "201"
						},
						"color": "#043f61"
					},
					{
						"y": 79.8076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "166"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.4423076923077,
						"dataLabels": {
							"enabled": false,
							"format": "159"
						},
						"color": "#0d4440"
					},
					{
						"y": 69.23076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "144"
						},
						"color": "#09472e"
					},
					{
						"y": 64.42307692307693,
						"dataLabels": {
							"enabled": false,
							"format": "134"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.78260869565217,
						"dataLabels": {
							"enabled": false,
							"format": "327"
						},
						"color": "#043f61"
					},
					{
						"y": 72.7536231884058,
						"dataLabels": {
							"enabled": false,
							"format": "251"
						},
						"color": "#0c4250"
					},
					{
						"y": 68.98550724637681,
						"dataLabels": {
							"enabled": false,
							"format": "238"
						},
						"color": "#0d4440"
					},
					{
						"y": 62.60869565217392,
						"dataLabels": {
							"enabled": false,
							"format": "216"
						},
						"color": "#09472e"
					},
					{
						"y": 56.231884057971016,
						"dataLabels": {
							"enabled": false,
							"format": "194"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.80851063829788,
						"dataLabels": {
							"enabled": false,
							"format": "728"
						},
						"color": "#043f61"
					},
					{
						"y": 73.13829787234043,
						"dataLabels": {
							"enabled": false,
							"format": "550"
						},
						"color": "#0c4250"
					},
					{
						"y": 70.07978723404256,
						"dataLabels": {
							"enabled": false,
							"format": "527"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.48936170212765,
						"dataLabels": {
							"enabled": false,
							"format": "500"
						},
						"color": "#09472e"
					},
					{
						"y": 61.03723404255319,
						"dataLabels": {
							"enabled": false,
							"format": "459"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.677419354838712,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.2950819672131195,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.76510067114094,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.118110236220474,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.639004149377592,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.031602708803615,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.829493087557607,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.9095607235142165,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.706521739130432,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.951008645533145,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.1400560224089631,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.13464235624124,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.1297709923664097,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.546099290780147,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.052631578947366,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.545454545454541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.802721088435371,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.21897810218978,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.512195121951216,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.23232323232324,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.6191950464396245,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.41121495327103,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.122448979591832,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.956521739130432,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.452674897119337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.4172461752433909,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.050279329608941,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.366812227074234,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.21917808219178,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.905472636815922,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -52.67857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.981132075471695,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.545454545454541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.157894736842103,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.3653846153846145,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.41293532338308,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.216867469879515,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.433962264150942,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.944444444444442,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.21739130434783,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.241590214067276,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.179282868525892,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.243697478991598,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.185185185185187,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.1914893617021267,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.450549450549453,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.181818181818187,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.123339658444026,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.199999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=80"
			},
			{
				"x": 9,
				"text": "30-39<br>n=305"
			},
			{
				"x": 15,
				"text": "40-49<br>n=443"
			},
			{
				"x": 21,
				"text": ">=50<br>n=1428"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=21"
			},
			{
				"x": 34,
				"text": "30-39<br>n=154"
			},
			{
				"x": 40,
				"text": "40-49<br>n=323"
			},
			{
				"x": 46,
				"text": ">=50<br>n=719"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=112"
			},
			{
				"x": 59,
				"text": "30-39<br>n=208"
			},
			{
				"x": 65,
				"text": "40-49<br>n=345"
			},
			{
				"x": 71,
				"text": ">=50<br>n=752"
			}
		],
		"dataTable": {
			"MSM:<30": [
				80,
				72,
				64,
				62,
				56,
				52
			],
			"MSM:30-39": [
				305,
				298,
				254,
				241,
				225,
				195
			],
			"MSM:40-49": [
				443,
				434,
				387,
				368,
				347,
				309
			],
			"MSM:>=50": [
				1428,
				1426,
				1310,
				1269,
				1224,
				1122
			],
			"Non-MSM:<30": [
				21,
				21,
				19,
				19,
				19,
				15
			],
			"Non-MSM:30-39": [
				154,
				147,
				137,
				123,
				99,
				76
			],
			"Non-MSM:40-49": [
				323,
				321,
				294,
				276,
				243,
				169
			],
			"Non-MSM:>=50": [
				719,
				716,
				687,
				657,
				603,
				489
			],
			"Unknown:<30": [
				112,
				53,
				44,
				42,
				38,
				33
			],
			"Unknown:30-39": [
				208,
				201,
				166,
				159,
				144,
				134
			],
			"Unknown:40-49": [
				345,
				327,
				251,
				238,
				216,
				194
			],
			"Unknown:>=50": [
				752,
				728,
				550,
				527,
				500,
				459
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_5.json
// module id = 300
// module chunks = 0